<template>
    <div>
        <div class="popup__content">
            <div class="add-worker__top mb24">
                <div class="text-size-l text-bold text-color">Сотрудник</div>
            </div>
            <div style=" width: 100%;">
				<div class="flex-row mb16">
					<div style="width: 266px">
	                    <input-multi
	                         @chunk="setPersonInput"
	                         name="worker-name"
                             :disabled="true"
	                         :is-error="form.worker.name.error"
	                         :error-text="form.worker.name.errorText"
	                         v-model="form.worker.name.value"
	                         :fields="form.worker.name.fields"
	                         @focus="removeError(form.worker.name)"
                             :auto-focus="true"
	                         :placeholderInput="'Фамилия Имя Отчество'"
	                         @blur="blur(form.worker.name)"
	                         :placeholder="'Фамилия Имя Отчество'"></input-multi>
	                </div>
					<div style="width: 266px;">
	                    <input-styled
	                    name="worker-post"
	                    :placeholder="'Должность'"
                        :disabled="true"
	                    :placeholderInput="'Должность'"
	                    v-model="form.worker.post.value"
	                    @focus="form.worker.post.error=false"
	                    :is-error="form.worker.post.error">
	                    </input-styled>
	                </div>
					<div style="width: 172px; height: 40px;">
                        <input-styled
                            name="worker-post"
                            :placeholder="'Группа'"
                            :disabled="true"
                            :placeholderInput="'Группа'"
                            v-model="form.selectGroup.value"
                            @focus="form.selectGroup.error=false"
                            :is-error="form.selectGroup.error">
                        </input-styled>
	                </div>
				</div>
                <div class="flex-row mb16">
                    <div style="width: 172px;">
                        <input-styled
                        name="worker-phone"
                        :placeholder="'Телефон'"
                        :placeholderInput="'Телефон'"
                        :disabled="true"
                        v-model="form.worker.phone.value"
                        @focus="form.worker.phone.error=false"
                        :error-text="form.worker.phone.errorType === 'use' ? 'Этот номер уже существует':form.worker.phone.errorType === 'mobile' ? 'Только мобильные номера':''"
                        :is-error="form.worker.phone.error"
                        :mask="{mask:'+7(999)999-99-99',showMaskOnHover: false}">
                        </input-styled>
                    </div>

                    <div style="width: 172px">
                        <input-styled
                        name="worker-post"
                        :placeholder="'E-mail'"
                        :placeholderInput="'E-mail'"
                        :disabled="true"
                        v-model="form.worker.email.value"
                        :error-text="form.worker.email.errorType === 'use' ? 'Этот email уже существует':form.worker.email.errorType === 'rule' && form.worker.email.value.length ? 'Некорректный email':''"
                        @focus="form.worker.email.error=false"
                        :is-error="form.worker.email.error">
                        </input-styled>
                    </div>

					<div style="width: 172px">
                        <input-styled
                        name="worker-post"
                        :placeholder="'E-mail'"
                        :placeholderInput="'E-mail'"
                        :disabled="true"
                        v-model="form.worker.email.value"
                        :error-text="form.worker.email.errorType === 'use' ? 'Этот email уже существует':form.worker.email.errorType === 'rule' && form.worker.email.value.length ? 'Некорректный email':''"
                        @focus="form.worker.email.error=false"
                        :is-error="form.worker.email.error">
                        </input-styled>
                    </div>

					<div style="width: 172px; height: 40px;">
						<input-select
							@change="form.selectContractType.error=false"
							@open="form.selectContractType.error=false"
							:tag="'div'"
							:isError="form.selectContractType.error"
							v-model="form.selectContractType.value"
							:options="selectContractTypeOptions"
							:placeholder="'Тип договора'"
							:list-style="{'max-height': 'none'}"></input-select>
	                </div>
                </div>
				<div class="flex-row mb16" style="width: 172px">
					<input-styled
					name="worker-rate"
					:placeholder="'Ставка'"
					:placeholderInput="'Ставка'"
					v-model="form.worker.rate.value"
					@focus="form.worker.rate.error=false"
					:is-error="form.worker.rate.error">
					</input-styled>
				</div>
				<div class="flex-row mb32">
					<textarea-field :class="'full'"
									v-model="form.worker.note.value"
									:error-text="''"
									:is-error="form.worker.note.error"
									@focus="form.worker.note.error=false"
									placeholder="Примечание"
									:add-style="{minHeight: 80 + 'px'}"></textarea-field>
				</div>
            </div>
            <div class="row-b mt32">
                <div class="row-b__col elem-pos-fix mr24">
                    <submit-btn class="" @click.native="send" :type="form.btnType">
                        <span class="i mr4" style="margin-top: -2px;" :class="{'i-ok7':form.btnType=='normal'}"></span>Сохранить
                    </submit-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import InputStyled from '@/components/forms/InputStyled.vue';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue';
    import InputSelect from '@/components/forms/InputSelect.vue';
    import InputSelectNew from '@/components/forms/InputSelectNew.vue';
    import InputMulti from '@/components/forms/InputMulti.vue';
    import {scrollTo} from "@/helpers/animate";
	import RightRadioSelect from '@/components/forms/RightRadioSelect.vue';
	import TextareaField from '@/components/forms/TextareaField.vue';

    export default {
        name: "SchemeWorker",
        components: {
            InputStyled,
            SubmitBtn,
            InputSelect,
            InputMulti,
            InputSelectNew,
			RightRadioSelect,
			TextareaField
        },
        props: {
            usersGroupedCurrentIndex: {
                default: false
            }
        },
        mounted(){
            if(this.editUser.name){
                let fio = this.editUser.name.split(' ');
                this.form.worker.name.value = this.editUser.name;
                this.form.worker.name.fields.lastName.value = fio[0];
                this.form.worker.name.fields.firstName.value = fio[1] ? fio[1] : ' ';
                this.form.worker.name.fields.secondName.value = fio[2] ? fio[2] : ' ';
            }
            if(this.editUser.post){
                this.form.worker.post.value = this.editUser.post;
            }
            if(this.editUser.email){
                this.form.worker.email.value = this.editUser.email;
            }
            if(this.editUser.phone){
                this.form.worker.phone.value = this.editUser.phone;
            }
            if(this.editUser.scheme.note){
                this.form.worker.note.value = this.editUser.scheme.note;
            }
            if(this.editUser.scheme.rate){
                this.form.worker.rate.value = this.editUser.scheme.rate;
            }
            if(this.editUser.scheme.type){
                this.form.selectContractType.value = this.editUser.scheme.type;
            }
            if(this.editUser.department){
                this.form.selectGroup.value = this.getOptionsDepartmentsName(this.editUser.department);
            } else if(this.usersGroupedCurrentIndex && this.usersGroupedCurrentIndex !== 'dismiss') {
                this.form.selectGroup.value = this.getOptionsDepartmentsName(this.usersGroupedCurrentIndex);
            }
        },
        data() {
            return {
                options: [
                  {name: '<span class=text-color-orange2>Читатель</span>', id: 1},
                  {name: '<span class=text-color-green>Редактор</span>', id: 2},
                  {name: '<span class=text-color-dark-blue>Модератор</span>', id: 28},
                  {name: '<span>Нет доступа</span>', id: 0}
                ],
				selectContractTypeOptions: ['СЗ', 'ГПХ', 'ТК', 'ИП'],
                form:{
                    selectGroup: {
                        value: '',
                        error: false,
                    },
					selectContractType: {
                        value: '',
                        error: false,
                    },
                    worker: {
                        name: {
                            name: 'workerName',
                            value: '',
                            fields: {
                                lastName: {
                                    name: 'lastName',
                                    value: '',
                                    delimiter: ' ',
                                    placeholder: 'Фамилия',
                                },
                                firstName: {
                                    name: 'firstName',
                                    value: '',
                                    delimiter: ' ',
                                    placeholder: 'Имя',
                                },
                                secondName: {
                                    name: 'secondName',
                                    value: '',
                                    delimiter: '',
                                    placeholder: 'Отчество',
                                },
                            },
                            required: true,
                            error: false,
                            errorText: '',
                            disabled: false,
                            focus:false,
                            sortScroll: 7
                        },
                        post: {
                            value: '',
                            error: false,
                        },
                        phone: {
                            value: '',
                            error: false,
                            errorType: 'empty',
                        },
                        email: {
                            value: '',
                            error: false,
                            errorType: 'empty',
                        },
						rate: {
							value: '',
							error: false,
						},
						note: {
							value: '',
							error: false,
						},

                    },
                    btnType: 'normal',
                },
            }
        },
        methods: {
            setPersonInput: function (field) {
                if(field.value !== undefined && field.name !== undefined){
                    this.form.worker.name.fields[field.name].value = field.value;
                }
            },
            blur(field){
                field.focus = false;
            },
            removeError: function(field) {
                field.error = false;
                field.focus = true;
            },
            close(){
                this.$store.commit('popups/close', {name: this.popups.schemeWorker.name});
                //На всякий случай очистим данные для редактирования раздела
                this.$store.commit('rulesStaff/setEditUser',[]);
                if(this.editUser.id){
                    this.$nextTick(()=>{
                        scrollTo('#user_'+this.this.editUser.id);
                    })
                }
            },
            send(){
                if(this.editUser.banned){
                    this.close();
                } else {
                    let error = false;

                    if(!this.form.selectContractType.value || this.form.selectContractType.value.length == 0){
                        if(this.form.selectContractType.error){
                            this.form.selectContractType.error = false;
                            setTimeout(() => {
                                this.form.selectContractType.error = true;
                            });
                        }else{
                            this.form.selectContractType.error = true;
                        }
                        error = true;
                    }

                    if(this.form.worker.rate.value.length == 0){
                        this.repeatFieldError('rate');
                        error = true;
                    }


                    if(!error){
                        this.form.btnType = 'load';
                        let params = {
                            id: this.editUser.id ? this.editUser.id : false,
                            form:{
                                selectContractType: this.form.selectContractType.value,
                                rate: this.form.worker.rate.value,
                                note: this.form.worker.note.value,
                                type: 'saveUserScheme',
                            }
                        };

                        this.$store.dispatch('rulesStaff/addUser', params).then((result)=>{
                            this.form.btnType = 'normal';
                            this.close();
                        });
                    }
                }

            },
            getOptionsDepartmentsName(id){
                let this_ = this, result;

                this.usersGrouped.forEach(function(item, i, arr) {
                    if(item.id == id){
                        result = item.name;
                        return false;
                    }
                });

                return result;
            },
            repeatFieldError(field){
                if(this.form.worker[field].error){
                    this.form.worker[field].error = false;
                    setTimeout(() => {
                        this.form.worker[field].error = true;
                    });
                }else{
                    this.form.worker[field].error = true;
                }
            }
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                usersGrouped: state => state.rulesStaff.usersByDepartmentList,
                topSections: state => state.rules.topSectionsStaff,
                editUser: state => state.rulesStaff.editUser,
                currentUser: state => state.users.user,
            }),
            admins(){
                let admins = [];
                for(let g in this.usersGrouped){
                    for(let u in this.usersGrouped[g].users){
                        if(this.usersGrouped[g].users[u].is_owner && this.usersGrouped[g].users[u].name != 'Админ Тестовый'){
                            admins.push(this.usersGrouped[g].users[u])
                        }
                    }
                }
                return admins;
            },
            selectOptionsDepartments(){
                let result = [];
                this.usersGrouped.forEach(function(item, i, arr) {
                    result.push(item.name);
                });
                return result;
            },
            selectedDepartmentId(){
                let this_ = this, result;

                this.usersGrouped.forEach(function(item, i, arr) {
                    if(item.name == this_.form.selectGroup.value){
                        result = item.id;
                        return false;
                    }
                });
                return result;
            },
            disabledCheckbox(){
                return !this.currentUser.access_rights.is_owner || this.editUser.banned || this.editUser.is_owner && this.editUser.id !== this.currentUser.id
            }
        },
    }
</script>

<style scoped>

</style>
